import * as Yup from 'yup';

import { parseCurrency } from 'utils';

const validationConvenienceForm = Yup.object({
  mainLanguages: Yup.array().test(
    'mainLanguages_required',
    'Vui lòng chọn ngôn ngữ',
    (value) => value?.length > 0,
  ),

  totalFloors: Yup.number()
    .required('Số phòng không được để trống')
    .test('min_of_total_floors',
      'Số tầng phải là số nguyên lớn hơn 0',
      (value) => parseCurrency(value) > 0),

  totalRooms: Yup.number()
    .required('Số phòng không được để trống')
    .test('min_of_total_rooms',
      'Số phòng phải là số nguyên lớn hơn 0',
      (value) => parseCurrency(value) > 0),
});

export default validationConvenienceForm;
